import {
  FULL_USER_STATUSES_OPTIONS,
  ROLES_NAMES
} from '../../../../../../../constants'
import { ROLES } from '../../../../../../Permission'
import { ColumnsType } from 'antd/es/table'
import {
  TUsersTable,
  TUsersTableFilters,
  TUsersTableFiltersFunc
} from './types'
import { Sorter } from '../../../../../../../components/Sorter/Sorter'
import { SortOrder } from 'antd/es/table/interface'
import { Link } from '../../../../../../../components/Link'
import { Dropdown } from '../../../../../../../components/Dropdown'

import { fetchContractCategories } from '../../../../../../../pages/CRUDUser/api'
import { DescriptionCell } from '../../../../../../../components/DescriptionCell/DescriptionCell'
import { ReactComponent as FilterApplied16 } from '../../../../../../../assets/svg/FilterApplied16.svg'
import { ReactComponent as Filter16 } from '../../../../../../../assets/svg/Filter16.svg'
import { fetchDepartments } from './api'
import {
  Status,
  USER_STATUS_TYPES_TO_CLASSNAME
} from '../../../../../../../components/Status'
import { StartChat } from '../../../../../../../components/StartChat/StartChat'
import { onStartChat } from '../../../../../utils'
import { UserMenu } from './UserMenu'
import { routes } from '../../../../../../../router'

export const USERS_ROLES_TABS = [
  { label: ROLES_NAMES.community_hospital_admin, value: ROLES.HOSPITAL_ADMIN },
  { label: ROLES_NAMES.community_hospital_user, value: ROLES.HOSPITAL_USER }
]

export const columns = (
  filters: TUsersTableFilters,
  applyFilters: TUsersTableFiltersFunc,
  userRole: string | null,
  hospitalId: string,
  onArchive: (row: TUsersTable) => void,
  canArchiveUsers: boolean,
  canCrudUsersInHSDetails: boolean
): ColumnsType<TUsersTable> => {
  let cols: ColumnsType<TUsersTable> = [
    {
      dataIndex: 'name',
      key: 'name',
      width: 200,
      title: ({ sortOrder, sortColumn }) => (
        <Sorter<TUsersTable>
          dataIndex="name"
          sortColumn={sortColumn}
          sortOrder={sortOrder as SortOrder}
        >
          Name
        </Sorter>
      ),
      sorter: true,
      showSorterTooltip: false,
      render: (_, { first_name, last_name, uuid }) => (
        <Link to={`${routes.createUserProfile}/${uuid}?fromCommunity=true`}>
          {first_name} {last_name}
        </Link>
      )
    },
    {
      dataIndex: 'status',
      key: 'status',
      width: 112,
      title: ({ sortOrder, sortColumn }) => (
        <Sorter<TUsersTable>
          dataIndex="status"
          sortColumn={sortColumn}
          sortOrder={sortOrder as SortOrder}
        >
          Status
        </Sorter>
      ),
      filterDropdown: (props) => (
        <Dropdown.Filter<TUsersTableFilters, TUsersTableFiltersFunc, unknown>
          items={FULL_USER_STATUSES_OPTIONS}
          applyFilters={applyFilters}
          appliedFilters={filters}
          field="statuses"
          {...props}
        />
      ),
      render: (_, { status, uuid }) => (
        <div className="row space-between align-center">
          <Status.Default className={USER_STATUS_TYPES_TO_CLASSNAME[status]}>
            {status}
          </Status.Default>
          {status === 'Active' && (
            <StartChat onClick={() => onStartChat(uuid)} />
          )}
        </div>
      ),
      filterIcon: !!filters?.statuses?.length ? (
        <FilterApplied16 />
      ) : (
        <Filter16 />
      ),
      filterSearch: true,
      sorter: true,
      showSorterTooltip: false
    },
    {
      dataIndex: 'email',
      key: 'email',
      width: 200,
      title: ({ sortOrder, sortColumn }) => (
        <Sorter<TUsersTable>
          dataIndex="email"
          sortColumn={sortColumn}
          sortOrder={sortOrder as SortOrder}
        >
          Email
        </Sorter>
      ),
      sorter: true,
      showSorterTooltip: false
    },
    {
      dataIndex: 'phone_number',
      key: 'phone_number',
      width: 200,
      title: 'Phone number',
      render: (_, { phone_number }) => (phone_number ? phone_number : <>–</>)
    }
  ]
  if (!userRole) {
    cols.unshift({
      dataIndex: 'role',
      key: 'role',
      width: 180,
      title: ({ sortOrder, sortColumn }) => (
        <Sorter<TUsersTable>
          dataIndex="role"
          sortColumn={sortColumn}
          sortOrder={sortOrder as SortOrder}
        >
          Role
        </Sorter>
      ),
      render: (text) => ROLES_NAMES[text] ?? <>–</>,
      sorter: true,
      showSorterTooltip: false
    })
  }
  if (
    (userRole !== ROLES.HOSPITAL_ADMIN && userRole !== ROLES.FINANCE) ||
    !userRole
  ) {
    cols = [
      ...cols,
      {
        dataIndex: 'contract_categories',
        key: 'contract_categories',
        width: 240,
        title: 'Contract categories',
        filterDropdown: (props) => (
          <Dropdown.Filter<TUsersTableFilters, TUsersTableFiltersFunc, unknown>
            applyFilters={applyFilters}
            appliedFilters={filters}
            searchCallback={fetchContractCategories}
            field="contract_categories"
            asyncSearch
            className="rfp-list-dropdown-table"
            {...props}
          />
        ),
        render: (_, { contract_categories }) => {
          return (
            <DescriptionCell
              content={contract_categories}
              text={contract_categories}
            />
          )
        },
        filterIcon: !!filters?.contract_categories?.length ? (
          <FilterApplied16 />
        ) : (
          <Filter16 />
        ),
        filterSearch: true,
        showSorterTooltip: false
      },
      {
        dataIndex: 'departments',
        key: 'departments',
        width: 200,
        title: 'Departments',
        filterDropdown: (props) => (
          <Dropdown.Filter<TUsersTableFilters, TUsersTableFiltersFunc, unknown>
            applyFilters={applyFilters}
            appliedFilters={filters}
            searchCallback={() => fetchDepartments(hospitalId, userRole)}
            field="departments"
            asyncSearch
            className="rfp-list-dropdown-table"
            {...props}
          />
        ),
        render: (_, { departments }) => {
          return <DescriptionCell content={departments} text={departments} />
        },
        filterIcon: !!filters?.departments?.length ? (
          <FilterApplied16 />
        ) : (
          <Filter16 />
        ),
        filterSearch: true,
        showSorterTooltip: false
      }
    ]
  }

  if (canCrudUsersInHSDetails) {
    cols.push({
      title: '',
      dataIndex: 'action',
      key: 'action',
      width: 40,
      fixed: 'right',
      render: (_, row) => {
        const canSeeActions = !('can_be_managed' in row) || row.can_be_managed
        return canSeeActions ? (
          <UserMenu
            user={row}
            onArchive={onArchive}
            canArchiveUsers={canArchiveUsers}
          />
        ) : null
      }
    })
  }
  return cols
}

export const userActions = [
  {
    key: 'edit',
    label: 'Edit'
  },
  {
    key: 'archive',
    label: 'Archive'
  }
]
